module.exports = __webpack_public_path__ + "static/media/ico-chisel.04f9cce1.svg";